import { landingPage } from '../constants/actions'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case landingPage.SET_LANDING_PAGE: {
      return { ...state, ...(action.payload || {}) }
    }
    case landingPage.GET_LANDING_PAGE_ERROR: {
      return {
        ...state,
        formError: true,
      }
    }
    case landingPage.SET_LANDING_PAGE_SUBDOMAIN: {
      const { subdomain } = action.payload

      return {
        ...state,
        subdomain,
      }
    }
    default:
      return state
  }
}
